declare let THREE: any;
import { TextureUtilsService } from '../services/texture-utils.service';
import { ImageUtilsService } from '../services/image-utils.service';
import { UnitsManagerService } from '../services/units-manager.service';

export class WallSize extends (THREE.Object3D as { new(): any; }) {

    constructor(
        private textureUtils: TextureUtilsService,
        private imageUtils: ImageUtilsService,
        private unitsManager: UnitsManagerService
    ) {

        super();

        const sizeLineOffset = 5;
        const sizeTextMeshWidth = 100;
        const sizeTextMeshHeight = 50;
        const sizeLineMaterial = new THREE.LineBasicMaterial({
            color: 0x8C8C8C,
            depthWrite: false,
            depthTest: false
        });

        const buildLine = function (vertices, name) {
            const geometry = new THREE.Geometry();
            geometry.vertices = geometry.vertices.concat(vertices);
            const line = new THREE.Line(geometry, sizeLineMaterial);
            line.name = name;
            line.renderOrder = 2;
            return line;
        };

        this.textureUtils.createOrUpdateMaterialMap();

        THREE.Object3D.call(this);

        const lineOffset = sizeLineOffset * -1;

        const linesContainer = new THREE.Object3D();
        linesContainer.name = 'lines';

        const horizontal = buildLine([
            new THREE.Vector3(0, 0, 0),
            new THREE.Vector3(1, 0, 0)
        ], 'horizontal');
        horizontal.position.y = lineOffset;
        linesContainer.add(horizontal);

        const verticalLeft = buildLine([
            new THREE.Vector3(0, 0, 0),
            new THREE.Vector3(0, lineOffset, 0)
        ], 'vertical left');
        linesContainer.add(verticalLeft);

        const verticalRight = buildLine([
            new THREE.Vector3(1, 0, 0),
            new THREE.Vector3(1, lineOffset, 0)
        ], 'vertical right');
        linesContainer.add(verticalRight);

        const plane = new THREE.Mesh(new THREE.PlaneBufferGeometry(sizeTextMeshWidth, sizeTextMeshHeight),
            new THREE.MeshBasicMaterial({
                transparent: true,
                depthWrite: false,
                depthTest: false
            }));
        plane.position.y = (sizeLineOffset + sizeTextMeshHeight / 2) * -1;
        plane.name = 'sizeText';
        plane.visible = false;
        plane.renderOrder = 2;

        this.name = 'size';
        this.add(plane);
        this.add(linesContainer);

        this.rotation.x = -Math.PI / 2;
        this.visible = false;
    }

    update() {
        const wall = this.parent;
        if (wall) {
            const wallSize = wall.getSize(new THREE.Vector3());
            const wallLength = wallSize.length;
            const wallLengthInUnits = this.unitsManager.getWallLength(wallLength);
            // var img = this.imageUtils.textToImage(wallLengthInUnits);

            const mesh = this.getObjectByName('sizeText');
            mesh.visible = true;
            mesh.position.x = wallLength / 2;
            mesh.rotation.z = -wall.rotation.y;

            // this.textureUtils.createOrUpdateMaterialMap(mesh, img);

            const horizontal = this.getObjectByName('lines');
            horizontal.scale.x = wallLength;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/custom/wall-size.ts